import type { FaireProductEntity } from "../../entity_types/product";

export const p_n357f6ggdz: FaireProductEntity = {
  token: "p_n357f6ggdz",
  type: "product",
  name: "FUSHIMI",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/5045a032e55115f19cad1f2f9c61bd5b69c6aae32632d69628930cfa29297af4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0863d6be13bf9d2f7a9475937f835d252649588e5a17fff54e3b87fb41545102.jpeg",
    "https://cdn.faire.com/fastly/015792a680039dd5438d43f5b131ccdaa28ef519e5eb2700e36dee36985962c7.jpeg",
    "https://cdn.faire.com/fastly/0b796a2e96fac8bf7c0ffce68fd10f772606588f57be9386d5c5f749ae28cbf1.jpeg",
    "https://cdn.faire.com/fastly/c83182a52de78a070c4ab731731da3f7c1fd8efaaeefda923cb6ba3d101a1edd.jpeg",
    "https://cdn.faire.com/fastly/8d03b17fbf6398a0cd7b3cf5868528236210f5fa0e93461cfcd46413339ffb35.jpeg",
  ],
  priceDollars: 24,
  description:
    "Inspired by the sacred Fushimi Inari Shrine, where endless vermillion torii gates weave through a serene bamboo forest, creating a pathway of tradition, devotion, and timeless beauty.\n\ndamp earth, moso bamboo, cinnamon fern, choji incense, creeping moss\n\nWe collaborated on this collection with the incredibly talented Tokyo-based artist Keisuke Shoda, founder of Studio The Blue Boy. Known for his playful aesthetic that blends traditional Japanese style with a modern, whimsical twist, his artwork beautifully captures the essence of some of our favorite parts of Japan.\n\nThese beautiful hand-painted ceramics are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8 ounces (226g), comes in our signature Japan Collection box.\n",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T13:49:20.632Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
